import { useQuery } from '@tanstack/react-query'
import { Flex, Radio, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import { useFormik } from 'formik'
import CustomDataTable from 'general/components/CustomDataTable'
import BaseTextField from 'general/components/Forms/BaseTextField'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import Global from 'general/utils/Global'
import Utils, {
  findObjectInArray,
  getYearsFromDates,
} from 'general/utils/Utils'
import ValidationSchema from 'general/utils/ValidationSchema'
import { useAppSelector } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import useToken from 'hooks/useToken'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useRef, useState } from 'react'
import DraggableModal from '../DragableModal/DraggableModal'
import { queryKeys } from './queries'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import useFilter from 'hooks/useFilter'
import useGetSerials from 'hooks/Queries/useGetSerials'
import _, { repeat } from 'lodash'
import TableAction from 'general/components/GroupButton/TableAction'
import { IconAction } from 'general/components/GroupButton/styles'
import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'
import RegistrationHelper from 'general/helpers/RegistrationHelper'
import { REGISTRATION_STATUS } from 'general/constants/AppConstants'
import CustomTag from 'general/components/CustomTag'
import ModalEditRegistration from 'features/TvanHandle/components/ModalEditRegistration'

FindRegistrationModal.propTypes = {
  selectableRows: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onExistDone: PropTypes.func,
  title: PropTypes.string,
  showTab: PropTypes.bool,
  textButtonTab1: PropTypes.string,
  textButtonTab2: PropTypes.string,
  checkBoxShow: PropTypes.bool,
  buttonAgreeOnlick: PropTypes.func,
  buttonAgreeTab2Onlick: PropTypes.func,
  onRowClicked: PropTypes.func,
  buttonAgreeVisibility: PropTypes.bool,
  defaultTab: PropTypes.number,
}

FindRegistrationModal.defaultProps = {
  selectableRows: false,
  show: false,
  onClose: null,
  showTab: true,
  onExistDone: null,
  textButtonTab1: 'Hóa đơn',
  textButtonTab2: 'Hóa đơn trên hệ thống khác',
  checkBoxShow: true,
  buttonAgreeVisibility: false,
}

function FindRegistrationModal(props) {
  const {
    show,
    onHide,
    title,
    onRowClicked,
    selectableRows,
    buttonAgreeVisibility,
    defaultTab,
    isInvoice = true,
    createDateObject,
    value,
  } = props
  const { token } = useToken()
  const { debouncedSearch, setSearch } = useSearchDebounce('')
  const modalRef = useRef(null)
  const modalRefDetails = useRef(null)
  const modalRequest = useRef(null)
  const [currentTab, setCurrentTab] = useState(0)
  const [clearSelected, setClearSelected] = useState(false)
  const [showEditRegis, setShowEditRegis] = useState({ show: false })
  const [showDetailRequest, setShowDetailRequest] = useState({ show: false })
  const [filter, setFilter] = useFilter('gFilterRegis')
  const [dateSerial, setDateSerial] = useState([])
  const [typeView, setTypeView] = useState(2)
  const { data: serials } = useGetSerials(undefined, dateSerial)

  const formik = useFormik({
    initialValues: {
      no: '',
      serial: '',
      taxAuthorityCode: '',
      date: dayjs().utc().format('L'),
    },
    validationSchema: ValidationSchema.findInvoice,
    enableReinitialize: false,
    validateOnChange: false,
  })

  const {
    data: dataSource,
    isLoading: gettingListData,
    refetch,
  } = useQuery({
    ...queryKeys.lists({
      companyId: value?.companyId,
      page: 0,
      limit: 1000,
      q: debouncedSearch,
    }),
    enabled: show,
  })

  useEffect(() => {
    if (show) {
      refetch()
    }
  }, [show, refetch])
  3
  useEffect(() => {
    console.log('value', value)
  }, [value])

  useEffect(() => {
    if (show) {
      refetch()
    }
  }, [debouncedSearch, show, filter])

  // useEffect(() => {
  //   if (show) {
  //     refetch()
  //   }
  // }, [debouncedSearch])

  const Item = ({ data }) => {
    return (
      <Tooltip title={data}>
        <div
          style={{
            width: '100%',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {data}
        </div>
      </Tooltip>
    )
  }

  const allColumns = [
    {
      name: 'STT',
      width: '80px',
      center: true,
      cell: (row, index) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {(filter?.page - 1) * filter?.limit + (index + 1)}
          </p>
        )
      },
    },
    {
      name: 'Ngày lập',
      width: '160px',
      center: true,
      cell: (row) => {
        const date = dayjs(row?.createDate)
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss.SSS') : ''}
          </p>
        )
      },
    },
    {
      name: 'Hình thức tờ khai',
      width: '200px',
      cell: (row) => {
        const data = RegistrationHelper.renderRegistrationType(row?.type)
        return <Item data={data} />
      },
    },
    {
      name: 'Hình thức hóa đơn',
      center: true,
      minWidth: '380px',
      cell: (row) => {
        const data = RegistrationHelper.renderInvoiceFormsOfRegistration(row)
        return <Item data={data} />
      },
    },
    {
      name: 'Thông báo tiếp nhận',
      minWidth: '250px',
      center: true,

      // sortable: true,
      // sortFunction: (a, b) => {
      //   let aT = a?.tax_authority_messages?.find(
      //     ({ typeCode }) => typeCode == 102,
      //   )?.messageId
      //   let bT = b?.tax_authority_messages?.find(
      //     ({ typeCode }) => typeCode == 102,
      //   )?.messageId
      //   if (!aT || !bT) return 0
      //   return aT.localeCompare(bT)
      // },
      cell: (row) => {
        const data = row?.tax_authority_messages?.find(
          ({ typeCode }) => typeCode == 102,
        )?.messageId
        return <Item data={data} />
      },
    },
    {
      name: 'Thông báo chấp nhận',
      sortable: true,
      grow: 0,
      center: true,
      minWidth: '250px',
      cell: (row) => {
        const data = row?.tax_authority_messages?.find(
          ({ typeCode }) => typeCode == 103,
        )?.messageId
        return <Item data={data} />
      },
    },
    {
      name: 'Trạng thái',
      center: true,
      style: {
        justifyContent: 'flex-start',
      },

      // sortable: true,
      // sortFunction: (a, b) => {
      //   let aT = RegistrationHelper.renderRegistrationStatus(a?.status)
      //   let bT = RegistrationHelper.renderRegistrationStatus(b?.status)
      //   if (!aT || !bT) return 0
      //   return aT.localeCompare(bT)
      // },

      cell: (row) => {
        let color
        switch (row?.status) {
          case REGISTRATION_STATUS.DRAFT:
            color = 'secondary'
            break
          case REGISTRATION_STATUS.TAX_VALID:
          case REGISTRATION_STATUS.SENT_TAX:
            color = 'success'
            break
          case REGISTRATION_STATUS.TAX_NOT_VALID:
          case REGISTRATION_STATUS.TAX_NOT_RECEIVE:
          case REGISTRATION_STATUS.TAX_NOT_ACCEPT:
          case REGISTRATION_STATUS.INACTIVE:
            color = 'danger'
            break
          default:
            color = 'primary'
            break
        }

        return (
          <CustomTag
            tagProps={{
              className: `badge badge-light-${color}`,
              // 'data-tag': 'allowRowEvents',
            }}
            style={{ margin: 0 }}
            text={RegistrationHelper.renderRegistrationStatus(row?.status)}
          />
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      width: '120px',
      style: {
        justifyContent: 'flex-end',
      },
      cell: (row) => (
        <Space size={'3px'} align="center">
          <TableAction
            titleActionText="Chỉnh sửa trạng thái tờ khai"
            icon={<IconAction className="fa-regular fa-pen-to-square" />}
            onClick={() => {
              setShowEditRegis({ show: true, data: row })
            }}
          />
        </Space>
      ),
    },
  ]

  const columns = allColumns.filter((column) => !column.hidden)

  const handleDoubleClickInvoice = (row) => {}

  // useEffect(() => {
  //   setDateSerial(getYearsFromDates(filters))
  // }, [])

  return (
    <>
      <DraggableModal
        applyText="Đóng"
        ref={modalRef}
        // handleApplyChanges={handleApplyChanges}
        title={title}
        hasApplyButton={buttonAgreeVisibility}
        isOpen={show}
        onOpenChange={() => onHide()}
        width={'90%'}
        styles={{
          header: {
            borderBottom: Utils.cn('1px solid', token.colorBorderSecondary),
            margin: 0,
          },
          body: {
            padding: 0,
          },
          footer: {
            borderTop: Utils.cn('1px solid', token.colorBorderSecondary),
          },
        }}
      >
        <div className="p-0">
          <>
            <div
              className="d-flex flex-column"
              style={{
                backgroundColor: '#f3f5f7',
                fontSize: '14px',
              }}
            ></div>
            <Flex gap={'5px'} className="p-3 w-100">
              <div style={{ width: '250px' }}>
                <CustomAntInput
                  type="search"
                  borderRadius="sm"
                  inputProps={{
                    defaultValue: debouncedSearch,
                    onChange: (e) => setSearch(e.target.value),
                  }}
                  // width={'25%'}
                />
              </div>
              {/* <div
                style={{
                  width: '100%',
                  maxWidth: '750px',
                  display: 'flex',
                }}
              >
                <FilterPopover
                  defaultValues={filterCriteria}
                  onApply={setFilter}
                  savedKey={'gFilterInvoiceErrAnnouce'}
                  customDate={1}
                  customDateArray={[
                    dayjs(createDateObject),
                    dayjs(createDateObject).add(7, 'day'),
                  ]}
                  // onchangeDate={onchangeDate}
                />
              </div> */}
            </Flex>
            <div className="m-3">
              <CustomDataTable
                wrapperClassName="max-h-600px"
                columns={columns}
                dataSource={dataSource?.rows}
                isLoading={gettingListData}
                scrollY="600px"
                isSelectable={selectableRows}
                pagination={{
                  currentPage: filter?.page,
                  rowsPerPage: filter?.limit,
                  total: dataSource?.total,
                  onChangePage: (page) => {
                    setFilter({
                      ...filter,
                      page,
                    })
                  },
                  onChangeRowsPerPage: (limit) => {
                    setFilter({
                      ...filter,
                      limit,
                      page: 1,
                    })
                  },
                }}
                selectedRows={{
                  clearSelectedRows: clearSelected,
                  handleSelectedRows: ({ selectedRows }) => {},
                }}
                isClickable
                handleDoubleClickRow={handleDoubleClickInvoice}
              />
            </div>
          </>
        </div>
      </DraggableModal>
      <ModalEditRegistration
        modalsState={showEditRegis}
        setModalsState={(value) => {
          setShowEditRegis(value)
        }}
        refetchList={() => {
          refetch()
        }}
      />
      {/* 
      <DraggableModal
        applyText="Đóng"
        ref={modalRequest}
        title={<>Chi tiết Request</>}
        isOpen={showDetailRequest.show}
        onOpenChange={() => {
          setShowDetailRequest({ show: false })
        }}
        handleApplyChanges={() => {
          setShowDetailRequest({ show: false })
        }}
        width={'70%'}
        styles={{
          header: {
            borderBottom: Utils.cn('1px solid', token.colorBorderSecondary),
            margin: 0,
          },
          body: {
            padding: 0,
          },
          footer: {
            borderTop: Utils.cn('1px solid', token.colorBorderSecondary),
          },
        }}
      >
        <div className="p-0">
          <>
            <div
              className="d-flex flex-column"
              style={{
                backgroundColor: '#f3f5f7',
                fontSize: '14px',
              }}
            ></div>
            <div
              className="row"
              style={{ height: 700, overflow: 'auto', marginRight: 0 }}
            >
              <div
                className="col-sm-12"
                style={{
                  overflow: 'auto',
                  maxHeight: '700px',
                  borderRight: '1px solid #ccc',
                  paddingLeft: 50,
                }}
              >
                <pre
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    cursor: 'pointer',
                  }}
                  onDoubleClick={() => {
                    navigator.clipboard.writeText(
                      showDetailRequest?.data?.request,
                    )
                    ToastHelper.showSuccess('Sao chép thành công')
                  }}
                  title="DoubleClick để sao chép"
                >
                  {JSON.stringify(
                    JSON.parse(showDetailRequest?.data?.request || '{}'),
                    null,
                    2,
                  )}
                </pre>
              </div>
            </div>
          </>
        </div>
      </DraggableModal> */}
    </>
  )
}

export default FindRegistrationModal
